import React from 'react';
import { connect } from 'react-redux';
import MiniCart from '../Components/MiniCart';
import { toggle, update as updateOrderRowQuantity, dismissNotification } from '../Actions/Cart.action';

const MiniCartContainer = props => (
    <MiniCart {...props} />
)

const mapStateToProps = state => {
    const { cart } = state;
    return {
        ...cart,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        toggle: () => dispatch(toggle()),
        updateOrderRowQuantity: (rowId, quantity) => dispatch(updateOrderRowQuantity(rowId, quantity)),
        removeOrderRow: (rowId) => dispatch(updateOrderRowQuantity(rowId, 0)),
        dismissNotification: (index) => dispatch(dismissNotification(index)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MiniCartContainer);